exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mtg-mask{position:fixed;top:0;left:0;z-index:9999;background-color:rgba(0,0,0,0.5);width:100%;height:100%;display:none}\n", ""]);
